import React, { Component } from "react";
import { Card, CardHeader, CardBody, Stack, Box } from "@chakra-ui/react";
import { JsonViewer } from '@textea/json-viewer'
import _ from "lodash";


function toFixed(num, fixed) {
    var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
    return num.toString().match(re)[0];
  }
  
  let omitByDeep = (obj, shouldOmit, convertBool, convertFloat) => {
    obj = _.clone(obj);
    _.forEach(obj, (value, key) => {
      if (shouldOmit(value, key)) {
        delete obj[key];
      }
      if (convertBool) {
        if (_.isBoolean(value)) {
          obj[key] = value ? "YES" : "NO";
        }
      }
      if (convertFloat) {
        if (Number.isFinite(value)) {
          if (!Number.isInteger(value)) {
            // must be a float?
            obj[key] = toFixed(value, 2);
          }
        }
      }
      if (_.isPlainObject(value)) {
        obj[key] = omitByDeep(value, shouldOmit, convertBool, convertFloat);
      }
    });
    return obj;
  };

export default class ObservationDebugInfo extends Component 
{
    constructor(props) 
    {
        super(props);

        this.state = 
        {

        };

    }

    render() 
    {

        var renderObj = {
            "title": this.props.observationSessionMode.name,
            "valueBag": this.props.valueBag,
            "environBag": this.props.environBag,
            "errorBag": this.props.errorBag,
            "categoryState": this.props.categoryState,
            "requiredState": this.props.requiredState,
            "observationResult": this.props.observationResult,
            "score": this.props.score,
            "onChangeEventsBag": this.props.onChangeEventsBag,
            "schema": this.props.schema
        };
        var jsonSchema = omitByDeep(
            renderObj,
            (v) => v === null || v === undefined || v === "" || v === 0,
            true,
            true
        );

        
        return(

            <Box p='4'>
            <Card>
              <CardHeader align="center">Observation Debug Info</CardHeader>
              <CardBody>
                <div style={{ width: "100%", height: "100%" }}>
                  <Stack direction={['column', 'row']}>
                    <Box>
                        <JsonViewer
                            value={renderObj}
                        />
                    </Box>
    
                  </Stack>
                </div>
              </CardBody>
            </Card>
          </Box>

        )


    }


}